<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedi">This book is dedicated to all those prisoners of war who suffered the agonies of sickness, hunger, exhaustion and freezing temperatures in Stalin’s empire.</p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedi.vue?1f47e3e0